module.exports = __webpack_public_path__ + "img/brand.ac965362.png";